import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AmaFooterModel } from '../../models/ama-footer.model';
@Component({
  selector: 'ama-footer',
  imports: [],
  templateUrl: './ama-footer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './ama-footer.component.scss',
})
export class AmaFooterComponent {
  @Input() version: string = '';

  public readonly model = new AmaFooterModel();
  public readonly categories = this.model.content.categories;
  public readonly social = this.model.content.social;
  public readonly utility = this.model.content.utility;

  public readonly copyright = `Copyright 1995 - ${new Date().getFullYear()} American Medical Association. All rights reserved.`;

  constructor(private router: Router) {}

  isExternal(url: string): boolean {
    return url.startsWith('http://') || url.startsWith('https://');
  }

  navigateTo(url: string, event: Event): void {
    event.preventDefault();
    this.router.navigateByUrl(url);
  }
}
